/**
 * 🌿 10-09 (Nina: "C looks greaaat (sage)", then status option #1): YOUR own message in the
 * Claude House is a dark sage bubble (the theme's secondary family) with soft green text,
 * and your status line is mint. It used to be the theme accent (tan #C4956A) with white
 * text at about 2.7:1. Canvases: the bubble https://claude.ai/artifact/QrKbvqEYSZW9ukXSP8b2vd
 * (board C), the status https://claude.ai/artifact/SWrAy3ZmeWKFfAUkcFCsfD (board 1).
 *
 * House only: the page adds THEME.ownBubble only when the status carries `house` (the
 * backend sends it only for autonomous_locals spaces). Every other space keeps its accent
 * bubble byte for byte: ownBubbleColors() then returns today's literal values.
 */

// Every text color here reads at 4.5:1 or better on `bg` (houseOwnBubble.test.js measures it).
export const HOUSE_OWN_BUBBLE = Object.freeze({
  bg: '#3D5446',     // the bubble + its tail
  name: '#CBE8CF',   // your name
  label: '#B5D3BA',  // "(Human Player)"
  time: '#B9C8BD',   // the time
  status: '#A8E6B4', // your status line (mint, no dot)
  text: '#EEF3EC',   // what you wrote
});

/** The colors YOUR message uses under this THEME: the House's sage set when the theme
 *  carries one, else today's accent look (the exact values the page used before). */
export function ownBubbleColors(THEME) {
  const o = THEME && THEME.ownBubble;
  if (o && typeof o === 'object' && typeof o.bg === 'string' && o.bg) {
    return { bg: o.bg, name: o.name, label: o.label, time: o.time, status: o.status, text: o.text };
  }
  return {
    bg: (THEME && THEME.accent) || '#667eea',
    name: 'rgba(255,255,255,0.95)',
    label: null,  // the label keeps its 0.7 opacity of the name color
    time: 'rgba(255,255,255,0.7)',
    status: null, // the status line keeps its light text + green dot (10-06 option C)
    text: '#fff',
  };
}
